// extracted by mini-css-extract-plugin
module.exports = {"privacyStatement":"_3MH9nYP"};
    if(module.hot) {
      // 1545369455501
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  